import { render, staticRenderFns } from "./EmailMessageManager.vue?vue&type=template&id=24273984"
import script from "./EmailMessageManager.vue?vue&type=script&lang=js"
export * from "./EmailMessageManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports